import { Components, Theme } from '@mui/material';

export const MuiAppBar: Components<Omit<Theme, 'components'>>['MuiAppBar'] = {
  styleOverrides: {
    root: {
      paddingTop: '10px',
      paddingBottom: '10px',
      verticalAlign: 'middle',
    },
  },
};
